
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","viewBox":"0 0 620 620","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M209.7 141.5c-9.4-8.6-9.4-24.5 0-33.1l78.5-78.5c8.6-8.6 23-8.6 31.7 0l78.5 78.5c9.4 9.4 9.4 24.5 0 33.1-4.3 3.6-9.4 5.8-15.1 5.8-5.8 0-12.2-2.2-16.6-6.5l-41-41.8v283c0 12.2-9.4 22.3-21.6 22.3-12.2 0-21.6-10.1-21.6-22.3V99l-41.8 41c-4.3 4.3-10.1 6.5-15.8 6.5-5.9.7-11.6-1.4-15.2-5zM484 171h-72c-11.5 0-22.3 7.9-23 19.4-1.4 13.7 8.6 23.8 21.6 23.8h61.9c6.5 0 11.5 4.3 11.5 10.8v326.2c0 6.5-5 8.6-11.5 8.6h-337c-6.5 0-11.5-2.2-11.5-8.6V225c0-6.5 5-10.8 11.5-10.8H196c11.5 0 22.3-7.9 23-19.4 1.4-13.7-9.4-23.8-22.3-23.8H124c-25.2 0-43.2 18-43.2 42.5V562c0 25.2 18 47.5 43.2 47.5h360c25.2 0 43.2-23 43.2-47.5V213.5c0-24.5-18-42.5-43.2-42.5z"}})])
          )
        }
      }
    